<template>
  <div>
    <el-form :model="ruleForm" label-position="left"
             :rules="rules"
             ref="ruleForm"
             style="margin-top:40px;width:860px"
             label-width="60px">
      <el-form-item label="标题" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="简介" prop="introduction">
        <el-input v-model="ruleForm.introduction"></el-input>
      </el-form-item>
      <el-form-item label="封面" prop="coverChart">
        <el-upload
          class="upload-demo"
          :action="serverPic"
          drag
          multiple
          :http-request="uploadFile"
          :on-success="successFile">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="作者" prop="author">
        <el-input v-model="ruleForm.author"></el-input>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <div id="summernote"></div>
      </el-form-item>
      <el-form-item>
        <el-button @click="submitForm('ruleForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import axios from 'axios'
  import qs from 'qs'
  import $ from 'jquery'
  export default {
    name: "edit_community",
    data() {
      return {
        serverPic: process.env.PUBLIC_URL+'/save_pic',
        fileList:[],
        ruleForm: {
          name: '',
          introduction:'',
          coverChart:'',
          author:'',
          content: '',
        },
        rules: {
          name: [
            { required: true, message: '请输入标题', trigger: 'blur' },
            { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
          ],
          introduction: [
            { required: true, message: '请输入简介', trigger: 'blur' },
            { min: 5, max: 50, message: '长度在 5 到 50 个字符', trigger: 'blur' }
          ],
          coverChart:[
            { required: true, message: '请上传缩略图', trigger: 'blur' },
          ],
          author:[
            { required: true, message: '请输入作者', trigger: 'blur' },
            { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
          ],
          content: [
            { required: true, message: '请输入内容', trigger: 'blur' }
          ],
        },
      }
    },
    mounted(){
      let that = this
      $("#summernote").summernote({
        lang:'zh-CN',
        height: 300,
        width: 800,
        placeholder: '此处输入内容',
        toolbar: [
          ['edit',['undo','redo']],//编辑
          ['headline', ['style']],//大字标题
          ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],//样式
          ['fontface', ['fontname','color','fontsize']],//字体
          ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],//对齐方式
          ['height', ['height']],//行高(自定义行高时一定不要忘记写这个)
          ['table', ['table']],//表单
          ['insert', ['link','picture','hr']],//插入链接，图片，下划线
          ['view', ['fullscreen', 'codeview']]//全屏，代码视图
        ],
        callbacks:{
          onImageUpload: function (files) {
            var formData = new FormData();
            formData.append("picFile", files[0]);
            $.ajax({
              url: that.serverPic,
              data: formData,
              cache: false,
              contentType: false,
              processData: false,
              type: 'POST',
              success: function (data) {
                $('#summernote').summernote('insertImage', process.env.PUBLIC_URL+data.path);
              },
              fail:function(){
                this.$message.error('错了哦，这是一条错误消息');
              }
            });
          }
        }
      });
    },
    methods: {
      submitForm(formName) {
        // let that = this
        this.ruleForm.content = $('#summernote').summernote('isEmpty')?'':'notEmpty'
        this.$refs[formName].validate((valid) => {
          console.log(valid)
          if (valid) {
            axios({
              method: 'post',
              url:process.env.PUBLIC_URL+'/save_data',
              data: qs.stringify({
                title:this.ruleForm.name,
                briefIntroduction:this.ruleForm.introduction,
                coverChart:this.ruleForm.coverChart,
                details:$('#summernote').summernote('code'),
                author:this.ruleForm.author
              }),
              timeout: 30000,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
              }
            }).then(
              (response) => {
                this.$message({
                  message: response.data.result,
                  type: 'success'
                });
              }
            )
          } else {
            return false;
          }
        });
      },
      uploadFile(item){
        let that = this
        var formData = new FormData();
        formData.append("picFile", item.file);
        $.ajax({
          url: this.serverPic,
          data: formData,
          cache: false,
          contentType: false,
          processData: false,
          type: 'POST',
          success: function (data) {
            // console.log(data);
            that.$message({
              message: '缩略图上传成功',
              type: 'success'
            });
            that.ruleForm.coverChart = data.path
          },
          fail:function(){
            that.$message.error('上传出错了哦，请重新上传');
          }
        });
      },
      successFile(response, file, fileList){
        console.log(response, file, fileList);
      }
    }
  }
</script>

<style>
  .upload-demo{
    text-align: left;
  }
  .el-upload input{
    display: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/wk_community/block/edit_community.vue